import { z } from 'zod';
import { adapterClient, handleApiError } from './client';
import { canonicalProjectId } from './projectViews';

const publicClient = z.object({
  name: z.string(),
  company: z.string().nullable(),
  website: z.string().nullable(),
});
const publicWorker = z.object({ name: z.string() });
const participant = z.object({
  accountId: z.string().regex(/^0x[0-9a-f]{64}$/),
  displayName: z.string().nullable(),
  contactEmail: z.string().email().nullable().default(null),
  profiles: z
    .object({
      principalId: z.string().regex(/^0x[0-9a-f]{32}$/),
      client: publicClient.nullable(),
      worker: publicWorker.nullable(),
    })
    .nullable(),
  clientImage: z.boolean(),
  workerImage: z.boolean(),
});
export type ProjectParticipant = z.infer<typeof participant>;
export async function getProjectParticipants(id: string, signal?: AbortSignal) {
  try {
    const { data } = await adapterClient.get<unknown>(
      '/projects/' + canonicalProjectId(id) + '/participants',
      { signal }
    );
    return z
      .object({
        client: participant,
        coordinator: participant,
        workers: z.array(participant).default([]),
      })
      .parse(data);
  } catch (error) {
    handleApiError(error, 'load project participants');
  }
}
